module.exports = __webpack_public_path__ + "static/img/manual_zh_27.fccab39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_27.png
// module id = VgMj
// module chunks = 4